<script setup>
defineProps({
  label: { type: String, default: '' },
  required: Boolean,
  error: { type: [String, Array], default: '' },
  help: { type: String, default: '' },
  // A reminder, not an error: worth filling in, not required.
  hint: { type: String, default: '' },
  id: { type: String, default: '' },
})
</script>

<template>
  <div class="group min-w-0">
    <div v-if="label" class="field-label flex items-center gap-1">
      <label :for="id || undefined" class="label">{{ label }}<span v-if="required" class="ml-0.5 text-red-600" :title="$t('common.required')">*</span></label>
      <slot name="label-extra" />
    </div>
    <slot />
    <p v-if="error" class="mt-1 text-xs text-red-600">{{ Array.isArray(error) ? error[0] : error }}</p>
    <p v-else-if="hint" class="mt-1 text-xs text-amber-700 dark:text-amber-300"><i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i> {{ hint }}</p>
    <p v-else-if="help" class="mt-1 text-xs text-faint">{{ help }}</p>
  </div>
</template>
